import React, { Component } from "react";
import { Container, Row } from "react-bootstrap";

import Socials from "../socials/Socials"
import "./Footer.scss";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        }
    }

    render() {

        let socials = this.state.data.socials;
        let copyright = this.state.data.copyright;

        return (
            <section id="footer">
                <Container fluid>
                    <div className="socials">
                        <Socials data={socials} />
                    </div>
                    <Row className="name">
                        <p>{copyright}</p>
                    </Row>
                </Container>
            </section>
        );
    }
};

export default Footer;
